import React from 'react';

import classname from '@search/classname/src';
import { Checkbox } from '@vtblife/uikit';
import { OptionType } from '@vtblife/uikit/legacy';
import { TimeLimit, TransportType } from '@search/filter-enums/enums';

import { TransportLimitFilter } from '../../../../models/Filter';

import './styles.css';

const cn = classname.bind(null, 'MobileTransportLimitFilterView');

interface ITransportLimitFilter {
    filter: TransportLimitFilter;
    handleChange: (value: TransportLimitFilter) => void;
    classNameGroup?: string;
}

const OPTIONS_TYPE: OptionType<TransportType>[] = [
    { label: 'Пешком', value: TransportType.FOOT },
    { label: 'На транспорте', value: TransportType.PUBLIC_TRANSPORT },
];

const OPTIONS_TIME: OptionType<TimeLimit>[] = [
    { label: '5 мин', value: TimeLimit.MAX_5_MINUTES },
    { label: '10 мин', value: TimeLimit.MAX_10_MINUTES },
    { label: '15 мин', value: TimeLimit.MAX_15_MINUTES },
    { label: '20 мин', value: TimeLimit.MAX_20_MINUTES },
    { label: '30 мин', value: TimeLimit.MAX_30_MINUTES },
];

export const TransportLimitNewFilter: React.FC<ITransportLimitFilter> = ({
    filter,
    handleChange,
    classNameGroup
}) => {
    const onChangeType = React.useCallback((value: boolean, option: TransportType) => {
        let timeLimit = filter.timeLimit;

        if (value) {
            if (! timeLimit) timeLimit = TimeLimit.MAX_15_MINUTES;
            handleChange(new TransportLimitFilter(
                timeLimit,
                option
            ));
        } else {
            handleChange(new TransportLimitFilter(
                TimeLimit.UNKNOWN,
                TransportType.UNKNOWN
            ));
        }
    }, [ filter.timeLimit, handleChange ]);

    const onChangeTimeLimit = React.useCallback((value: boolean, option: TimeLimit) => {
        let transportType = filter.transportType;

        if (value) {
            if (! transportType) transportType = TransportType.FOOT;
            handleChange(new TransportLimitFilter(
                option,
                transportType
            ));
        } else {
            handleChange(new TransportLimitFilter(
                TimeLimit.UNKNOWN,
                TransportType.UNKNOWN
            ));
        }
    }, [ filter.transportType, handleChange ]);

    return (
        <div className={classNameGroup}>
            <div className={cn('transport-type')}>
                {OPTIONS_TYPE.map(type => (
                    <div
                        key={type.value}
                        className={cn('label-box', {
                            left: type.value === TransportType.FOOT,
                            right: type.value === TransportType.PUBLIC_TRANSPORT,
                        })}
                    >
                        <Checkbox
                            name={type.label}
                            value={filter.transportType === type.value}
                            onChange={value => onChangeType(value, type.value)}
                            variant='filter'
                            block
                        >
                            {type.label}
                        </Checkbox>
                    </div>
                ))}
            </div>
            {OPTIONS_TIME.map(type => (
                <div key={type.value} className={cn('box')}>
                    <Checkbox
                        name={type.label}
                        value={filter.timeLimit === type.value}
                        onChange={value => onChangeTimeLimit(value, type.value)}
                        variant='filter'
                        block
                    >
                        {type.label}
                    </Checkbox>
                </div>
            ))}
        </div>
    );
};
